import React, { useState } from 'react';
import { Collapse, Form } from 'react-bootstrap';
import DropDown from '../../../../../../../DropDown/DropDown';
import ProjectTaskAPIs from '../../../../../../../../MasonyFixingsAPIs/ProjectTaskAPIs/ProjectTaskAPIs';
import { MdAddCircle } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../../../../../../Contexts/ToastContext';

export default function AddTaskProduct({projectTaskID, handleAddNew}){

    const {addToast} = useToast();
    const navigate = useNavigate();
    const [addNew, setAddNew] = useState(false);
    const [sending, setSending] = useState(false);
    const [productID, setProductID] = useState('');
    const [quantity, setQuantity] = useState('');

    const handleCancel = () => {
        if(addNew){
        setAddNew(false);
        setProductID('');
        setQuantity('')
        }
        setAddNew(!addNew)
    }

    const addNewTaskProduct = () => {
        setSending(true);
        const postJSON = {
            product_id: productID,
            quantity: quantity
        }
        if(productID !=='' && quantity !== ''){
            ProjectTaskAPIs.PostProjectTaskProduct(projectTaskID, postJSON)
            .then((response) => {
                if(response.status === 200){
                    handleAddNew();
                    setSending(false);
                    handleCancel();
                    addToast({ message: "Product added successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                console.log(err)
                if(err.response.status === 401){
                    if(err.response.data.logout){
                        navigate('/login');
                    }
                    else{
                        window.alert(err.response.data.message)
                        setSending(false);
                    }
                }
            })
        }
    }

    // return(
    //     <tr>
    //         <td>
    //             <DropDown.Products required value={productID} onChange={(e) => setProductID(e.target.value)} />
    //         </td>
    //         <td>
    //             <Form.Control type='number' required value={quantity} onChange={(e) => setQuantity(e.target.value)} />
    //         </td>
    //         <td>
    //             <button disabled={sending} onClick={() => addNewTaskProduct()}><MdAddCircle/></button>
    //         </td>
    //     </tr>
    // )

    return(
        <div className="project-section">
            <div className="project-header-actions">
                <button
                    disabled={sending || !addNew}
                    onClick={() => addNewTaskProduct()}
                    className="save-btn"
                    style={addNew ? {display: 'block'} : {display: 'none'}}
                >
                    {sending ? 'Saving...' : 'Save'}
                </button>

                    <button
                        disabled={sending}
                        type="button"
                        className="cancel-btn"
                        onClick={() => handleCancel()}
                    >
                        {addNew ? 'Cancel' : <><MdAddCircle /> Add New</>}
                    </button>
                
            </div>

            <Collapse in={addNew}>

            <div className="project-section-body">

                <div className="project-section-body-column">
                    <div className="project-section-body-item m-1">
                        <span className="label">Product:</span>
                        <DropDown.Products required disabled={sending} className='editable-field' value={productID} onChange={(e) => setProductID(e.target.value)} />
                    </div>
                </div>

                <div className="project-section-body-column">
                    <div className="project-section-body-item m-1">
                        <span className="label">Quantity:</span>
                        <Form.Control type='number' disabled={sending} className='editable-field' required value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                    </div>
                </div>

            </div>
            </Collapse>

        </div>
    )

}